import React from "react";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const PlanPreviewCard = ({
    planName,
    bestFor,
    highlights,
    isPopular = false,
    buttonLabel = "Know More",
    buttonTo,
}) => (
    <article
        className={`relative flex h-full flex-col rounded-3xl border p-6 shadow-[0_18px_50px_rgba(59,130,246,0.18)] transition hover:-translate-y-1 hover:shadow-[0_22px_58px_rgba(59,130,246,0.26)] ${
            isPopular
                ? "border-indigo-300 bg-indigo-100/80 ring-2 ring-indigo-100 hover:bg-indigo-100"
                : "border-indigo-100 bg-indigo-50/60 hover:border-indigo-200 hover:bg-indigo-100/60"
        }`}
    >
        {isPopular && (
            <span className="absolute right-5 top-5 rounded-full bg-indigo-600 px-3 py-1 text-xs font-semibold text-white shadow-sm">
                Most Popular
            </span>
        )}

        <div className="pr-24">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-indigo-600">
                Plan
            </p>
            <h3 className="mt-2 text-2xl font-bold tracking-tight text-slate-950">
                {planName}
            </h3>
        </div>

        <p className="mt-4 text-sm leading-6 text-slate-600">{bestFor}</p>

        <ul className="mt-6 flex-1 space-y-3">
            {highlights.map((highlight) => (
                <li
                    key={highlight}
                    className="flex gap-3 text-sm leading-6 text-slate-700"
                >
                    <CheckCircle2
                        size={17}
                        className="mt-0.5 shrink-0 text-indigo-500"
                        aria-hidden="true"
                    />
                    <span>{highlight}</span>
                </li>
            ))}
        </ul>

        <Link
            to={buttonTo}
            className={`mt-7 inline-flex items-center justify-center gap-2 rounded-2xl px-5 py-3 text-sm font-semibold transition ${
                isPopular
                    ? "bg-indigo-600 text-white shadow-sm hover:bg-indigo-700"
                    : "border border-indigo-100 bg-indigo-50 text-indigo-700 hover:bg-indigo-100"
            }`}
        >
            {buttonLabel}
            <ArrowRight size={16} aria-hidden="true" />
        </Link>
    </article>
);

export default PlanPreviewCard;
